<template>
    <div class="container-fluid" style="margin: 20px 5px;">
        <div class="card">
            <div class="card-header">
                <img v-if="course.imageFileName" v-bind:src="course | s3url" alt="images">
                <div v-else class="container-fluid d-flex flex-column justify-content-center align-items-center align-content-center">
                    <i class="fa fa-5x fa-image" style="margin-top: 60px;"></i>
                </div>
                <div class="avatar accent-primary-bd" v-if="course.author && course.author.profileFileName">
                    <img v-bind:src="course.author | s3url">
                </div>
            </div>
            <div class="card-body d-flex flex-column justify-content-between">
                <div class="category text-dark">
                    {{ course.name }}
                </div>
                <div>
                    <div class="name">
                        <router-link :to="{ name: 'CourseInfo', params: { id: course.id }}">Learn More ...</router-link>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-1" style="border-top: 1px solid black; padding-top: 10px;">
                        <div class="evaluate">
                            <div class="price">
                                <span class="price-now">{{ course.price ? "R" + course.price : "" }}<span v-if="course.price" class="text-smaller"> Excl. VAT</span></span>
                            </div>
                        </div>
                        <div>
                            <router-link class="btn-site-primary" v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">Continue</router-link>
                            <button v-else class="btn-site-primary" v-on:click="addToCart">{{ course.price > 0 ? "Add to cart" : "Enrol" }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .text-smaller {
        font-size: 12px;
        white-space: nowrap;
    }

    .name a {
        color: black;
        font-size: 20px;
        font-weight: 600;
    }

    .name a:hover{

    }

    .price{
        font-size: 25px;
        font-weight: 700;
    }

    .avatar {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 50px;
        height: auto;
        border-radius: 50%;
        overflow: hidden;
    }

    .category {
        font-size: 25px;
        font-weight: 700;
    }

    .card {
        border: none;
        margin: 0 auto;
        max-width: 338px;
        min-height: 450px;
        box-shadow: black 2px 2px 12px 2px;
        border-radius: 10px;
    }

    .card-header {
        position: relative;
        padding: 0;
        height: 200px;
        overflow: hidden;
    }

        .card-header img {
            width: 100%;
            height: 100%;
        }

    .card-body {
    }

    a.btn-site-primary {
        padding: 10px 28px;
    }

    .enroll a {
        padding: 12px 40px;
        border-radius: 34px;
        display: inline-block;
        background: #3d3c79;
        color: #fff !important;
        font-size: 13px;
        font-weight: 500;
        text-transform: inherit;
        box-shadow: 0 8px 6px -6px black;
    }

    .enroll {
        padding-top: 15px;
    }

    .add-cart-card {
        padding: 12px 25px;
        border-radius: 34px;
        display: inline-block;
        background: #fecc00;
        color: #fff !important;
        font-size: 13px;
        font-weight: 500;
        text-transform: inherit;
        box-shadow: 0 8px 6px -6px black;
    }

        .add-cart-card:hover {
            background-color: #fbb545;
        }

    .add-cart {
        background-color: none !important;
        padding: 0px;
    }
</style>
<script>
    export default {
        name: 'CourseCardComponent',
        props: {
            course: Object,
            type: String
        },
        methods: {
            addToCart() {
                this.$store.commit("addToCart", {
                    type: "course",
                    id: this.course.id,
                    name: this.course.name,
                    price: this.course.price,
                    priceUsd: this.course.priceUsd,
                    imageFileName: this.course.imageFileName
                });
            }
        },
        computed: {

        }
    }
</script>

<style scoped>
</style>